export default __webpack_public_path__ + "static/media/chicken-yellow.23f74528.svg";